import React, { useState } from 'react';
import {
  AppBar, Toolbar, Box, Button, IconButton, Drawer,
  List, ListItem, ListItemButton, ListItemText,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Menu as MenuIcon, Close as CloseIcon, ArrowForward as ArrowIcon } from '@mui/icons-material';

const LIME = '#00F1A7';
const DARK = '#05080F';

export default function PublicHeader({ activePage = '' }) {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const navLinks = [
    { label: 'Quem Somos', href: '/quem-somos' },
    { label: 'Início', href: '/' },
    { label: 'Recursos', href: '/recursos' },
    { label: 'Meus Cursos', href: '/meus-cursos' },
  ];

  const scrollTo = (href) => {
    if (href.startsWith('/')) {
      navigate(href);
      setDrawerOpen(false);
      return;
    }
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setDrawerOpen(false);
  };

  return (
    <AppBar position="sticky" elevation={0} sx={{ bgcolor: DARK, borderBottom: `1px solid #2a2a2a` }}>
      <Toolbar sx={{
        maxWidth: 1200,
        mx: 'auto',
        width: '100%',
        px: { xs: 2, md: 4 },
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}>
        <Box
          component="img"
          src={process.env.PUBLIC_URL + '/images/logo_conecta_church_white_v2.svg'}
          alt="ConectaChurch"
          sx={{ height: 40, cursor: 'pointer' }}
          onClick={() => navigate('/')}
          onError={(e) => { e.target.style.display = 'none'; }}
        />

        <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 1 }}>
          {navLinks.map((l) => (
            <Button
              key={l.label}
              onClick={() => scrollTo(l.href)}
              sx={{
                color: activePage === l.label ? LIME : 'rgba(255,255,255,0.8)',
                fontWeight: activePage === l.label ? 700 : 500,
                borderBottom: activePage === l.label ? `2px solid ${LIME}` : '2px solid transparent',
                borderRadius: 0,
                px: 2,
                '&:hover': { color: LIME, bgcolor: 'transparent', borderColor: LIME },
              }}
            >
              {l.label}
            </Button>
          ))}
          <Button
            variant="contained"
            onClick={() => navigate('/login')}
            endIcon={<ArrowIcon />}
            sx={{ bgcolor: LIME, color: DARK, fontWeight: 700, px: 3, ml: 2, '&:hover': { bgcolor: '#00C48C' } }}
          >
            Acessar sistema
          </Button>
        </Box>

        {/* Mobile */}
        <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center', gap: 1 }}>
          <Button
            variant="contained"
            size="small"
            onClick={() => navigate('/login')}
            sx={{ bgcolor: LIME, color: DARK, fontWeight: 700, fontSize: '0.75rem' }}
          >
            Acessar
          </Button>
          <IconButton color="inherit" onClick={() => setDrawerOpen(true)}>
            <MenuIcon />
          </IconButton>
        </Box>

        <Drawer
          anchor="right"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          PaperProps={{ sx: { width: 280, bgcolor: DARK, height: '100%' } }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2, borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
            <Box
              component="img"
              src={process.env.PUBLIC_URL + '/images/logo_conecta_church_white_v2.svg'}
              alt="ConectaChurch"
              sx={{ height: 32 }}
              onError={(e) => { e.target.style.display = 'none'; }}
            />
            <IconButton onClick={() => setDrawerOpen(false)} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <List sx={{ flex: 1, pt: 2 }}>
            {navLinks.map((l) => (
              <ListItem key={l.label} disablePadding>
                <ListItemButton
                  onClick={() => scrollTo(l.href)}
                  sx={{
                    py: 1.5,
                    color: activePage === l.label ? LIME : '#fff',
                    fontWeight: activePage === l.label ? 700 : 400,
                    '&:hover': { bgcolor: `${LIME}12` },
                  }}
                >
                  <ListItemText primary={l.label} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
          <Box sx={{ p: 2, borderTop: '1px solid rgba(255,255,255,0.1)' }}>
            <Button
              fullWidth
              variant="contained"
              onClick={() => { setDrawerOpen(false); navigate('/login'); }}
              sx={{ bgcolor: LIME, color: DARK, fontWeight: 700 }}
            >
              Acessar sistema
            </Button>
          </Box>
        </Drawer>
      </Toolbar>
    </AppBar>
  );
}
